import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { RootState } from "@/store";

type CorrectionsReducerType = {
  start: Nullable<Date>;
  stop: Nullable<Date>;
  user: Nullable<SmallUser>;
};

const initialState: CorrectionsReducerType = {
  start: new Date(),
  stop: new Date(),
  user: null,
};

const correctionsSlice = createSlice({
  name: "financeReport/corrections",
  initialState,
  reducers: {
    setStart(state, { payload }: PayloadAction<Nullable<Date>>) {
      state.start = payload;
    },

    setStop(state, { payload }: PayloadAction<Nullable<Date>>) {
      state.stop = payload;
    },

    setUser(state, action: PayloadAction<Nullable<SmallUser>>) {
      state.user = action.payload;
    },

    resetFilters(state) {
      state.start = null;
      state.stop = null;
      state.user = null;
    },
  },
});

export const { setStart, setStop, setUser, resetFilters } = correctionsSlice.actions;
export const correctionsSelector = (state: RootState) => state.financeReports.corrections;
export default correctionsSlice.reducer;
